<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,4C9,4,5,4,5,4C4.45,4,4,4.45,4,5C4,5.55,4.45,6,5,6C5,6,6,6,6,6C6,6,6,9,6,9C6,9.55,6.45,10,7,10C7.55,10,8,9.55,8,9C8,9,8,6,8,6C8,6,9,6,9,6C9.55,6,10,5.55,10,5C10,4.45,9.55,4,9,4C9,4,9,4,9,4ZM15.56,13.44C15.56,13.44,12.89,10.77,12.89,10.77C13.59,9.68,14,8.39,14,7C14,3.13,10.87,0,7,0C3.13,0,0,3.13,0,7C0,10.87,3.13,14,7,14C8.39,14,9.68,13.59,10.77,12.89C10.77,12.89,13.44,15.56,13.44,15.56C13.71,15.83,14.09,16,14.5,16C15.33,16,16,15.33,16,14.5C16,14.09,15.83,13.71,15.56,13.44C15.56,13.44,15.56,13.44,15.56,13.44ZM7,12C4.24,12,2,9.76,2,7C2,4.24,4.24,2,7,2C9.76,2,12,4.24,12,7C12,9.76,9.76,12,7,12C7,12,7,12,7,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SearchText',
} as DefineComponent
</script>
